export const HANDLE_OTP = "HANDLE_OTP";
export const HANDLE_OTP_SUCCESS = "HANDLE_OTP_SUCCESS";
export const HANDLE_OTP_FAILED = "HANDLE_OTP_FAILED";

export const handleOTP = (payload) => ({
  type: HANDLE_OTP,
  payload
});

